import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  // 注意：localStorage key 是 'token'，与 group-admin 保持一致
  const token = ref(localStorage.getItem('token') || '')
  const refreshToken = ref(localStorage.getItem('refreshToken') || '')
  const userInfo = ref(JSON.parse(localStorage.getItem('userInfo') || 'null'))
  const menuList = ref(JSON.parse(localStorage.getItem('menuList') || '[]'))
  const authorities = ref(JSON.parse(localStorage.getItem('authorities') || '[]'))

  const isAuthenticated = ref(!!token.value)

  // 计算属性：检查是否有某个权限
  const hasPermission = computed(() => {
    return (permission) => {
      if (!permission) return true
      return authorities.value.includes(permission)
    }
  })

  function login(loginToken, user, loginRefreshToken = '') {
    token.value = loginToken
    refreshToken.value = loginRefreshToken
    userInfo.value = user
    isAuthenticated.value = true
    // 注意：使用 'token' 作为 key
    localStorage.setItem('token', loginToken)
    if (loginRefreshToken) {
      localStorage.setItem('refreshToken', loginRefreshToken)
    }
    localStorage.setItem('userInfo', JSON.stringify(user))
  }

  function setUserInfo(user) {
    userInfo.value = user
    if (user.menuList) {
      menuList.value = user.menuList
      localStorage.setItem('menuList', JSON.stringify(user.menuList))
    }
    if (user.authorities) {
      authorities.value = user.authorities
      localStorage.setItem('authorities', JSON.stringify(user.authorities))
    }
    localStorage.setItem('userInfo', JSON.stringify(user))
  }

  function logout() {
    token.value = ''
    refreshToken.value = ''
    userInfo.value = null
    menuList.value = []
    authorities.value = []
    isAuthenticated.value = false
    // 注意：使用 'token' 作为 key
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('menuList')
    localStorage.removeItem('authorities')
  }

  return {
    token,
    refreshToken,
    userInfo,
    menuList,
    authorities,
    isAuthenticated,
    hasPermission,
    login,
    setUserInfo,
    logout
  }
})
